// extracted by mini-css-extract-plugin
export default {"topLines":"TopLines_topLines__1aUmV","line1":"TopLines_line1__LH06q","line2":"TopLines_line2__H6iVP"};